import * as React from 'react';
import { Toolbar, FilterPanelTrigger, ExportExcel, ColumnsPanelTrigger } from '@mui/x-data-grid-premium';
import { ToolbarButton } from '@mui/x-data-grid';
import FilterListIcon from '@mui/icons-material/FilterList';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
interface CustomToolbarProps {
  children?: React.ReactNode;
}

const CustomToolbar = ({ children }: CustomToolbarProps) => {
  return (
    <Toolbar>
      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>
      <Tooltip title="Filters">
        <FilterPanelTrigger render={<ToolbarButton />}>
          <FilterListIcon fontSize="small" />
        </FilterPanelTrigger>
      </Tooltip>
      <Tooltip title="Export">
        <ExportExcel render={<ToolbarButton />}>
          <FileDownloadIcon fontSize="small" />
        </ExportExcel>
      </Tooltip>
      {children}
    </Toolbar>
  );
};

export default CustomToolbar;
export { CustomToolbar };
